// 全局工具函数
let globalApp: any = null;

export function setGlobalApp(app: any) {
  globalApp = app;
}

export const $loading = {
  show: (...args: any[]) =>
    globalApp?.config.globalProperties.$loading?.show(...args),
  hide: () => globalApp?.config.globalProperties.$loading?.hide(),
};

export const $toast = {
  show: (message: string, duration?: number) =>
    globalApp?.config.globalProperties.$toast?.show(message, duration),
};
/**
 * 关闭页面loading
 */
function pageLoadMed() {
  const loading = document.getElementById("Loading");
  if (loading) {
    document.body.removeChild(loading);
  }
}
(window as any).pageLoadMed = pageLoadMed;
/**
 * 跳转APP
 */
function linkAppMed() {
  const downloadUrl = "xxlout_dfcf64appwtdytcj_random_0008402a";
  let applink = "";
  let adrlink = "";
  let linkUrl;
  let targetUrl = window.location.origin + "/views/finskillshub/maintain";
  applink =
    "eastmoney://wireless/h5/trade?url=" + encodeURIComponent(targetUrl);
  adrlink = "dfcft://router/h5?url=" + encodeURIComponent(targetUrl);
  linkUrl =
    "https://mlink.eastmoney.com/h52n/nlink.html?type=localurl&curl=" +
    downloadUrl +
    "&id=" +
    encodeURIComponent(applink) +
    "&word=&a_id=" +
    encodeURIComponent(adrlink);
  window.location.href = linkUrl;
}

(window as any).linkAppMed = linkAppMed;
